import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useParams } from "react-router";
import { BASE_API } from '../../api/Globals';
import { LABELTEXT } from '../../api/Globals';

import { helpHttp } from '../../helpers/helpHttp';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Dialog } from 'primereact/dialog';
import { Chip } from 'primereact/chip';
import { Button } from 'primereact/button';
import Menu from '../../components/sturtural/Menu';
import Loader from '../../components/sturtural/Loader';
import { Toast } from 'primereact/toast';
import { Paginator } from 'primereact/paginator';
import { ProgressSpinner } from 'primereact/progressspinner'

import MessageDetail from '../../components/sturtural/MessageDetail';
import { Tooltip } from 'primereact/tooltip';
import { FileUpload } from 'primereact/fileupload';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import html2pdf from 'html2pdf.js';
import { Avatar } from 'primereact/accordion';
import { Badge } from 'primereact/accordion';
import { storage } from '../../helpers/storage';

const Resumen = () => {

    const [message, setMessage] = useState(false);
    const [alumno, setAlumno] = useState(null);
    const [tutorDetalle, setTutorDetalle] = useState(null);
    const [prendas, setPrendas] = useState(null);
    const [loading, setLoading] = useState(true);
    const [cancelarDialog, setCancelarDialog] = useState(false);
    const [openDialogConfirmar, setOpenDialogConfirmar] = useState(false);
    const [frontal, setFrontal] = useState(null);
    const [reverso, setReverso] = useState(null);
    const [firma, setFirma] = useState(null);
    const [comprobante, setComprobante] = useState(null);
    const toast = useRef(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const [banderaEliminar, setBanderaEliminar] = useState(false)
    const [displayDialog, setDisplayDialog] = useState(false);
    const [selectItem, setSelectItem] = useState(null);
    const navigate = useNavigate();
    let { q } = useParams();
    const [lstDocumentos, setLstDocumentos] = useState([]);
    const idUsuario = storage.get('id');
    const idTienda = storage.get('IdTienda')
    const ciclo = storage.get('ciclo')
    const idPerfil = storage.get('perfilid');
    const [totalEntregados, setTotalEntregados] = useState(0)
    const [esMulti, setEsMulti] = useState(false)
    const [loadingMulti, setLoadingMulti] = useState(false);
    const [loadingEditar, setLoadingEditar] = useState(false);
    const [loadingPdf, setLoadingPdf] = useState(false);
    const [itemsPerPage, setItemsPerPage] = useState(5);
    const [currentPage, setCurrentPage] = useState(1);
    const [windowSize, setWindowSize] = useState(getWindowSize());

    const fileUploadRef = useRef(null);



    const dialogFuncMap = {
        cancelarDialog: setCancelarDialog,
        openDialogConfirmar: setOpenDialogConfirmar
    };
    const onHide = (name) => {
        dialogFuncMap[`${name}`](false);
    };

    const openDialog = (name) => {
        dialogFuncMap[`${name}`](true);
    }

    const AbrirCancelar = async (contenido) => {
        await setCancelarDialog(true);
    }


    const AbriConfirmacion = async (contenido) => {
        setBanderaEliminar(true)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: ('Cancelación de entrega realizada.'), life: 5000 });
        setTimeout(() => {
            navigate('/filtro/na')
            setBanderaEliminar(false);
            setLoading(false)
        }, 2500);
    }

    const handleLoadData = () => {
        obtenerMulti(1, itemsPerPage);
    };

    const onPageChange = (e) => {
        const newPage = e.page + 1; // Convertir de base 0 a base 1
        const rows = e.rows;
        if (newPage !== currentPage || itemsPerPage !== rows) {
            setItemsPerPage(rows)
            setCurrentPage(newPage);
            obtenerMulti(newPage, rows);
        }
    };

    useEffect(() => {
        if (isNormalInteger(window.atob(q))) {
            setLoading(true);
            helpHttp().post(`${BASE_API}DetalleEntrega/ObtenerDetalleEntregaList/${window.atob(q)}?IdCicloEscolar=${ciclo.IdCicloEscolar}`, {
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                },
            }).then(async (res) => {
                if (!res.err) {
                    if (res.some(x => x.IdAlumno === parseInt(window.atob(q)))) {

                        setAlumno(res);
                        let alumnoSel = res.find(x => x.IdAlumno === parseInt(window.atob(q)))
                        setTotalEntregados(alumnoSel.TotalEntregados)
                        setActiveIndex(res.findIndex(x => x.IdAlumno === parseInt(window.atob(q))))
                        setTutorDetalle(alumnoSel)

                        let tipoDocumento = JSON.parse(storage.get('ciclo').tipoDocumento)

                        let documentos = await Promise.all(
                            JSON.parse(alumnoSel.Documentos).map(async (documento) => {
                                let imagen = await getImagen(documento.IdDocumento)
                                return {
                                    idDocumento: documento.IdDocumento,
                                    idTipoDocumento: documento.IdTipoDocumento,
                                    TipoDocumento: documento.TipoDocumento,
                                    documento: imagen
                                }
                            })
                        );

                        const mergeDocumentos = unificarDocumentos(documentos, tipoDocumento)

                        setLstDocumentos(mergeDocumentos)

                        // getImagen(alumnoSel.IdDocFrontal).then(x => setFrontal(x));
                        // getImagen(alumnoSel.IdDocReverzo).then(x => setReverso(x));
                        // if (alumnoSel.IdDocFirma > 0) {
                        //     getImagen(alumnoSel.IdDocFirma).then(x => setFirma(x));
                        // }

                        // if (alumnoSel.IdComprobante > 0) {
                        //     getImagen(alumnoSel.IdComprobante).then(x => setComprobante(x));
                        // }
                    } else {
                        setAlumno(null);
                        setDisplayDialog(false)
                        //navigate('/filtro/na')
                    }
                } else {
                    setAlumno(null)
                    setDisplayDialog(false)
                    //navigate('/filtro/na')
                }
                setLoading(false);
            });
        } else {
            setMessage("Faltan parámetros importantes para realizar este proceso");
        }
    }, [q]);

    useEffect(() => {
        function handleWindowResize() {
            setWindowSize(getWindowSize());
        }

        window.addEventListener('resize', handleWindowResize);

        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);

    const unificarDocumentos = (documentos = [], catalogo = []) => {
        return catalogo.map(item => {
            const match = documentos.find(
                doc => doc.idTipoDocumento === item.IdTipoDocumento
            );

            return {
                idTipoDocumento: item.IdTipoDocumento,
                TipoDocumento: item.TipoDocumento,
                idDocumento: match?.idDocumento || null,
                obligatorio: item.obligatorio,
                documento: match?.documento || ""
            };
        });
    };

    function getWindowSize() {
        const { innerWidth, innerHeight } = window;
        return { innerWidth, innerHeight };
    }

    const getImagen = (IdDoc) => {
        let imagen = helpHttp().post(`${BASE_API}DetalleEntrega/ObtenerImagen/${IdDoc}`, {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            },
        })
        return imagen;
    }

    const isNormalInteger = (str) => {
        let n = ~~Number(str);
        return String(n) === str && n >= 0;
    }

    const basicDialogFooter = <Button type="button" label="Aceptar" onClick={() => setMessage(false)} icon="pi pi-check" className="p-button-secondary" />;

    const isMobile = () => {
        return (
            (navigator.userAgent.match(/Android/i)) ||
            (navigator.userAgent.match(/webOS/i)) ||
            (navigator.userAgent.match(/iPhone/i)) ||
            (navigator.userAgent.match(/iPod/i)) ||
            (navigator.userAgent.match(/iPad/i)) ||
            (navigator.userAgent.match(/BlackBerry/i))
        );
    }

    const CancelarEntrega = () => {
        setLoading(true)

        helpHttp().post(`${BASE_API}Entrega/SpdCancelarEntregaSistema`, {
            body: {
                IdEncEntrega: alumno[0].IdEncEntrega,
                IdUsuarioModificacion: storage.get('id'),
                IdAlumno: alumno[0].IdAlumno,
                IdCicloEscolar: ciclo.IdCicloEscolar,
                ParametrosExtras: ""
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
                body: {
                    sp: "SpdAgregarMovimientoUsuario",
                    tipo: 2,
                    parametros: [
                        { IdUsuario: idUsuario },
                        { IdTienda: idTienda },
                        { IdEtapa: 6 },
                        { IdEncEntrega: JSON.stringify([alumno[0].IdEncEntrega]) },
                        { IdAlumno: JSON.stringify([alumno[0].IdAlumno]) },
                        { IdCicloEscolar: ciclo.IdCicloEscolar },
                        { ParametrosExtra: "" },
                    ]
                },
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(response => {
                if (response.SUCCESS) {
                    if (response.ITEMS.ErrorNumber === 0) {
                        AbriConfirmacion()
                    }
                } else {
                    setLoading(false)
                    toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Fallo en conexión, intente de nuevo.", life: 5000 });
                }
            }).catch(error => {
                console.warn(error);
                setLoading(false)
                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Fallo en conexión, intente de nuevo.", life: 5000 });
            })
        })
    }

    const obtenerMulti = async (page, limit) => {
        setLoadingMulti(true);
        helpHttp().post(`${BASE_API}DetalleEntrega/PostDetalleEntregaPaginado`, {
            body: {
                IdAlumno: parseInt(window.atob(q)),
                IdCicloEscolar: ciclo.IdCicloEscolar,
                PageNumber: page,
                RowsOfPage: limit,
                ParametrosExtra: ""
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS) {
                let alumnos = res.ITEMS.map(x => { return { ...x, PrendasActivas: JSON.parse(x.PrendasActivas) } })
                let array = page !== 1 ? alumnos : [tutorDetalle, ...alumnos]
                setAlumno(array)
                setEsMulti(true)
            } else {
                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Error de conexión, intente de nuevo.", life: 5000 });
            }
            setLoadingMulti(false)
        })

    }

    const prendasTemplate = (prendas, index) => {
        return prendas.map((prenda, indexP) =>
            <>
                {/* <Chip icon={prenda.Entregado ? 'pi pi-check' : 'pi pi-times'} data-pr-tooltip={prenda.Entregado ? 'Entregado' : 'No entregado'} data-pr-position='bottom' label={`${prenda.Prenda}: ${prenda.Talla}`} className="custom-target-chip mr-2 mb-2" style={{ background: prenda.Entregado ? '#e0f3e9' : '#e5e5e5', color: '#9b2f3e', color: prenda.Entregado ? '#0e4a2e' : '', fontWeight: '600' }} /> */}
                <div data-pr-tooltip={prenda.Entregado ? 'Entregado' : 'No entregado'} data-pr-position='bottom' className="custom-target-chip mr-2 mb-2 rounded-sides text-left xl:text-center lg:text-center md:text-center sm:text-center" style={{ background: prenda.Entregado ? '#e0f3e9' : '#e5e5e5', color: '#9b2f3e', color: prenda.Entregado ? '#0e4a2e' : '', fontWeight: '600' }}>
                    <icon className={`mx-1 ${prenda.Entregado ? 'pi pi-check' : 'pi pi-times'}`} style={{ fontWeight: 'bold', fontSize: '16px' }} />
                    <label className='mr-1' style={{ fontWeight: '400' }}>{`${prenda.Prenda}: ${prenda.Talla}`}</label>
                </div>
            </>
        )
    }

    const toBase64 = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
    });

    const handleUpload = async (file, item) => {
        let data = { ...item }

        try {
            const base64 = await toBase64(file)
            data.formato = `.${file.name.split('.').pop()}`
            data.documento = base64;
            data.IdEncEntrega = tutorDetalle.IdEncEntrega
            data.IdTutor = tutorDetalle.IdTutor
            data.opcion = 'A';
        } catch (err) {
            console.warn(err)
        }
        setSelectItem(data);
        openDialog('openDialogConfirmar')
    }

    const handleEliminar = (item) => {
        let data = { ...item }
        data.IdEncEntrega = tutorDetalle.IdEncEntrega
        data.opcion = 'E';


        setSelectItem(data);
        openDialog('openDialogConfirmar')
    }

    const handleConfirmarEliminar = async (item) => {
        try {
            setLoadingEditar(true);
            const response = await helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
                body: {
                    sp: 'SpdRetirarArchivoEntrega',
                    opcion: 2,
                    parametros: [
                        { 'IdDocumento': item.idDocumento },
                        { 'IdEncEntrega': item.IdEncEntrega },
                        { 'idCicloEscolar': ciclo.IdCicloEscolar },
                        { 'idUsuario': idUsuario }
                    ]
                },
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            })

            if (response.ITEMS[0].succes !== 1) {
                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Falló al eliminar documento, intente de nuevo.", life: 6000 });
            } else {
                setLstDocumentos(prev =>
                    prev.map((doc) =>
                        doc.idTipoDocumento === item.idTipoDocumento
                            ? { ...doc, idDocumento: null, documento: '' }
                            : doc
                    )
                );
                toast.current.show({ severity: 'success', summary: 'Mensaje de éxito', detail: 'Eliminado correctamente.', life: 6000 })
            }
        } catch (err) {
            console.warn(err);
        } finally {
            setLoadingEditar(false)
            onHide('openDialogConfirmar');
            setSelectItem(null);
        }
    }

    const handleEditar = async (item) => {
        try {
            setLoadingEditar(true)
            const response = await helpHttp().post(`${BASE_API}Entrega/SpdEditarArchivoEntrega`, {
                body: {
                    IdDocumento: item.idDocumento,
                    IdEncEntrega: item.IdEncEntrega,
                    IdTutor: item.IdTutor,
                    IdTipoDocumento: item.idTipoDocumento,
                    Formato: item.formato,
                    Ruta: '',
                    IdUsuario: idUsuario,
                    IdCicloEscolar: ciclo.IdCicloEscolar,
                    Archivo: item.documento.replace('data:', '').replace(/^.+,/, '')
                },
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            })
            if (!response.SUCCESS) {
                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Falló al subir documento, intente de nuevo.", life: 6000 });
            } else {
                const img = await getImagen(response.ITEMS[0].IdDocumentoNuevo);
                setLstDocumentos(prev =>
                    prev.map((doc) =>
                        doc.idTipoDocumento === item.idTipoDocumento
                            ? { ...doc, idDocumento: response.ITEMS[0].IdDocumentoNuevo, documento: img }
                            : doc
                    )
                );
                toast.current.show({ severity: 'success', summary: 'Mensaje de éxito', detail: 'Guardado correctamente.', life: 6000 })
            };
        } catch (err) {
            console.warn(err)
        } finally {
            fileUploadRef.current?.clear();
            setLoadingEditar(false)
            onHide('openDialogConfirmar');
            setSelectItem(null);
        }

    }

    const ExportarPDF = (idAlumno) => {
        setLoadingPdf(true);
        helpHttp().post(`${BASE_API}Reportes/postObtenerReporte`, {
            body: {
                reporte: 23,
                Folio: idAlumno,
                IdCicloEscolar: ciclo.IdCicloEscolar

            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS) {
                const linkSource = `data:application/pdf;base64,${res.ITEMS}`;
                const downloadLink = document.createElement("a");
                const fileName = `Detalle_Entrega_${idAlumno}_Ciclo_${ciclo.IdCicloEscolar}.pdf`

                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            } else {
                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: 'Error de conexión, intente de nuevo.', life: 5000 })
            }
            setLoadingPdf(false);
        })
    }

    const DocumentoTemplate = (index, item) => {
        return <div key={index} className="col-12 p-3">
            <div className={`shadow-2 border-round surface-card mb-3 h-full flex-column justify-content-between flex`}>
                <div className="p-4 grid">
                    <div className='col-10'>
                        <span className={`inline-flex border-circle align-items-center justify-content-center`} style={{ 'width': "48px", 'height': "48px", 'borderRadius': "10px" }}>
                            <i className={`pi pi-images text-xl text-gray-600`}></i>
                        </span>
                        <span className="text-900 font-medium text-2xl">
                            {item.TipoDocumento} {item.obligatorio && <label style={{ color: 'red' }}>*</label>}
                        </span>
                    </div>
                    <div className='col-2' style={{justifyItems: 'right', alignContent: 'center'}}>
                        {(idPerfil == 1 || idPerfil == 19)  && (
                            <div className='text-right flex'>
                                <FileUpload ref={fileUploadRef} key={item.idDocumento} mode='basic' chooseLabel='' data-pr-tooltip='Editar' data-pr-position='top' name='file' accept='.png, .jpg, .jpeg' maxFileSize={20000000} auto customUpload uploadHandler={(e) => handleUpload(e.files[0], item)}
                                    chooseOptions={{
                                        icon: 'pi pi-pencil',
                                        label: '',
                                        className: 'p-button-rounded p-button-icon-only custom-target-chip '
                                        
                                    }} />
                                {!item.obligatorio && item.idDocumento && <Button rounded icon="pi pi-trash" className='p-button ml-2 custom-target-chip' data-pr-tooltip='Eliminar' data-pr-position='top' onClick={() => handleEliminar(item)} />}
                            </div>
                        )}
                    </div>
                </div>

                <div className='col-12'>
                    {item.documento.length > 0 &&
                        <img
                            style={{ 'display': 'block', 'width': '100%', 'height': '100%' }}
                            id='base64image'
                            src={item.documento}>
                        </img>
                    }
                </div>

                <div className="px-4 py-3 surface-100 text-right">
                    <div className="input-group">

                    </div>
                </div>
            </div>
        </div>
    };

    return (
        <>
            <Toast ref={toast} position='top-right' />
            <Menu link='nueva-solicitud' />


            {isMobile() &&
                <div className="col-12">
                    <div className="card">
                        <div className="surface-border pt-3 flex">
                            <button type="button" aria-label="Filtro" className="p-button p-component p-button-outlined w-6 mr-2" onClick={() => navigate("/filtro/na")}>
                                <span className="p-button-label p-c"><i className='pi pi-search'></i> Filtro</span><span role="presentation" className="p-ink"></span>
                            </button>
                            <button type='submit' aria-label="Pendientes" name="button-data" id="button-data" className="p-button p-component w-6 ml-2" onClick={() => navigate("/pendientes")}>
                                <span className="p-button-label p-c"><i className='pi pi-search'></i> Pendientes</span><span role="presentation" className="p-ink"></span>
                            </button>
                        </div>
                    </div>
                </div>}

            {(loading
                ?
                <div><Loader /></div>
                :
                (alumno != null && tutorDetalle != null
                    ?

                    <>
                        <div className="grid surface-section px-4 py-7 md:px-6 lg:px-8 text-center">
                            <div className='col-12 lg:col-3'></div>
                            <div className='col-12 lg:col-6'>
                                <div className="font-bold text-2xl">
                                    <span className='uppercase' style={{ color: '#9B2F3E' }}>TUTOR: {tutorDetalle.NombreTutor}</span>
                                </div>
                                <div className="mb-1">
                                    <label style={{ fontWeight: '700' }}>Entregado: <label style={{ fontWeight: '400', marginRight: '3px' }}>{tutorDetalle.Fecha} </label> </label>
                                    <label style={{ fontWeight: '700', marginLeft: '5px' }}> Ciclo escolar: <label style={{ fontWeight: '400' }}>{tutorDetalle.CicloEscolar}</label> </label>
                                </div>
                                <div className="mb-3">
                                    <label style={{ marginRight: '10px', fontWeight: '700' }}>Usuario: <label style={{ fontWeight: '400' }}>{tutorDetalle.NombreUsuario}</label></label>
                                    <label style={{ fontWeight: '700' }}>Sede: <label style={{ fontWeight: '400' }}>{tutorDetalle.NombreTienda}</label></label>
                                </div>
                            </div>
                            <div style={{ alignContent: 'center' }} className='col-12 lg:col-3'>
                                <div className='text-center lg:text-right'>
                                    <Button className='mr-2' label="Cancelar entrega" icon="pi pi-times" hidden={idPerfil == 1 ? false : idPerfil == 19 ? false : true} onClick={() => AbrirCancelar()}></Button>
                                    <Button className='p-button' loading={loadingPdf} icon='pi pi-download' tooltip="Descargar detalle" data-pr-position="top" style={{ color: '#FFFFFF', background: '#9b2f3e' }} rounded text onClick={() => ExportarPDF(parseInt(window.atob(q)))} />
                                </div>
                            </div>

                            <div className='col-12'>
                                <p className='mt-3' style={{ textAlign: 'left' }}>Total entregados <strong>{totalEntregados}</strong> </p>
                                <Tooltip target='.custom-target-chip' />
                                {loadingMulti !== false ?
                                    <ProgressSpinner style={{ height: '70px', marginBottom: '10px' }} /> :
                                    <Accordion multiple activeIndex={alumno.length === 1 ? [0] : null}>
                                        {alumno.map((alumno, index) =>
                                            <AccordionTab id='accordionMultientrega' tabIndex={index} key={index} contentClassName='text-left'
                                                header={
                                                    <div className='grid'>
                                                        <div className='col-11'>
                                                            <span className="flex align-items-center gap-2 w-full" style={{ color: alumno.IdTipoVale === 0 ? '#9b2f3e' : '#166d44' }}>
                                                                <i className='pi pi-user' style={{ borderRadius: '20px', padding: '5px', background: '#afaeae', color: 'white' }} />
                                                                <span className='text-left'>{alumno.Coordenadas} - {alumno.NombreAlumno}</span>
                                                            </span>
                                                        </div>
                                                        <div className='col-1' style={{ alignContent: 'center', textAlign: 'center' }}>
                                                            <i className={`${alumno.IdTipoVale === 0 ? 'pi pi-times ' : 'pi pi-check '} ml-auto`} style={{ fontSize: '15px', fontWeight: 'bold', color: alumno.IdTipoVale === 0 ? '#9b2f3e' : '#166d44' }} />
                                                        </div>
                                                    </div>
                                                }>
                                                <div key={index} className='grid'>
                                                    {/* <div className='border-1 col-12 xl:col-2  lg:col-2  md:col-3 sm:col-3     text-center xl:text-center lg:text-center md:text-center'>
                                                        <span style={{ fontWeight: 600 }}>CUPU: {alumno.Coordenadas}</span>
                                                    </div> */}
                                                    <div className='col-12 xl:flex lg:flex md:flex sm:flex'>
                                                        {prendasTemplate(alumno.PrendasActivas.length > 0 ? alumno.PrendasActivas : alumno.Prendas, index)}
                                                    </div>
                                                </div>

                                            </AccordionTab>
                                        )}
                                    </Accordion>
                                }
                                {esMulti === true &&
                                    <Paginator
                                        first={(currentPage - 1) * itemsPerPage}
                                        rows={itemsPerPage}
                                        totalRecords={totalEntregados}
                                        rowsPerPageOptions={[5, 10, 20, 50, totalEntregados]}
                                        onPageChange={onPageChange}
                                        template="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                    />
                                }
                                {(totalEntregados > 1 && esMulti === false) &&
                                    <div className='col-12'>
                                        <Button icon="pi pi-plus" id='btn-ver-mas' className='mt-2 p-button-outlined' label='Ver más' onClick={() => handleLoadData()} />
                                    </div>}
                            </div>
                        </div>

                        {lstDocumentos.length > 0 && lstDocumentos.map((x, index) => DocumentoTemplate(index, x))}
                    </>
                    :
                    <MessageDetail color="warn" mensaje="No se encontró la informacion requerida" />
                )

            )}

            <Dialog
                id='modalAvisoCambioCiclo'
                visible={displayDialog}
                draggable={false}
                closable={false}
                blockScroll={true}
                style={{ width: '400px', marginLeft: '10px', marginRight: '10px', height: '200px' }}
                header={
                    <div className="grid" style={{ alignItems: 'center', backgroundColor: '#9b2f3e', color: "white" }} >
                        <div className="col-12"> {"AVISO"}</div>
                    </div>
                }
                footer={
                    <div style={{ float: "right" }}>
                        <div>
                            {/*                                 <Button label="No" icon='pi pi-times' className="p-button-outlined p-component" onClick={() => {setDialogConfirmar(false); setCiclo(null)}}></Button>
 */}                                <Button label="Aceptar" icon='pi pi-check' className="p-button p-component" onClick={() => navigate('/filtro/na')}></Button>
                        </div>
                    </div>
                }
            >
                <div className="flex align-items-center justify-content-center">
                    <label style={{ fontSize: '14px', textAlign: 'center' }}>Alumno no encontrado en el ciclo <br /><strong>{ciclo.Descripcion}</strong></label>
                </div>
            </Dialog>

            <Dialog header="Aviso" visible={message} onHide={() => setMessage(false)} style={{ width: '400px' }} modal className="p-fluid" footer={basicDialogFooter}>
                <p>{message && message}</p>
            </Dialog>




            <Dialog
                id='modalAvisoCambioCiclo'
                visible={cancelarDialog}
                draggable={false}
                closable={false}
                blockScroll={true}
                style={{ width: '400px', marginLeft: '10px', marginRight: '10px', height: '200px' }}
                header={
                    <div className="grid" style={{ alignItems: 'center', backgroundColor: '#9b2f3e', color: "white" }} >
                        <div className="col-12"> {"AVISO"}</div>
                    </div>
                }
                footer={
                    <div style={{ float: "right" }}>
                        <div>
                            <Button label="No" disabled={loading} icon='pi pi-times' className="p-button-outlined p-component" onClick={() => { onHide('cancelarDialog') }}></Button>
                            <Button label="Sí" loading={loading} icon='pi pi-check' className="p-button p-component" onClick={() => {
                                CancelarEntrega()
                            }}></Button>
                        </div>
                    </div>
                }
            >
                <div className="flex align-items-center justify-content-center">
                    <label style={{ fontSize: '14px', textAlign: 'center' }}>
                        ¿Está seguro de cancelar esta<strong>{alumno !== null && alumno.length > 1 ? ' multientrega' : ' entrega'}?</strong><br />
                        {alumno !== null && alumno.length > 1 && 'Cancelará todas estas entregas'}

                    </label>
                </div>
            </Dialog>

            <Dialog id='modalAvisoCambioCiclo'
                header="CONFIRMACIÓN"
                visible={openDialogConfirmar}
                draggable={false}
                closable={false}
                blockScroll={true}
                style={{ width: '600px', marginLeft: '10px', marginRight: '10px', height: '300px' }}
                footer={
                    <div style={{ float: "right" }}>
                        <div>
                            <Button label="NO" icon='pi pi-times' disabled={loadingEditar ? true : false} className="p-button-outlined" onClick={() => { onHide('openDialogConfirmar'); setSelectItem(null); fileUploadRef.current?.clear(); }}></Button>
                            <Button label="SÍ" icon='pi pi-check' loading={loadingEditar} className="p-button p-component" onClick={() => selectItem.opcion === 'A' ? handleEditar(selectItem) : handleConfirmarEliminar(selectItem)}></Button>
                        </div>
                    </div>
                }>
                {selectItem &&
                    <div className="text-center">
                        <p style={{ fontSize: '15px' }}>¿Está seguro que desea {selectItem.opcion === 'E' ? 'eliminar' : 'guardar'} el archivo en <strong>{selectItem.TipoDocumento}</strong>?</p>

                        <img
                            src={selectItem.documento}
                            alt={selectItem.TipoDocumento}
                            width={100}
                            style={{ borderRadius: '6px' }}
                        />
                    </div>}
            </Dialog>


        </>
    )
}

export default Resumen;